<template>
  <div v-if="show" class="modal-overlay" @click.self="$emit('update:show', false)">
    <div class="approve-modal">
      <h4 class="modal-title">🗳 Согласование условий</h4>
      <p class="modal-tip">Запрос уйдёт администраторам. После подтверждения закройте рейс по согласованию.</p>

      <div class="summary">
        <div class="summary-row" v-for="line in summaryLines" :key="line.label">
          <span class="summary-label">{{ line.label }}</span>
          <span class="summary-value" :class="{ muted: line.muted }">{{ line.value }}</span>
        </div>
      </div>

      <label class="modal-field">
        <span class="modal-label">Кто перевозчик</span>
        <input type="text" v-model="whoCarrier" :disabled="loading" placeholder="ООО АЛТ" />
      </label>
      <label class="modal-field">
        <span class="modal-label">Чем обусловлен тариф</span>
        <input type="text" v-model="whyTariff" :disabled="loading" placeholder="Ниже рынка на 5%" />
      </label>
      <label class="modal-field">
        <span class="modal-label">Прежние условия</span>
        <input type="text" v-model="prevTerms" :disabled="loading" placeholder="Было 20-25 БД" />
      </label>
      <div v-if="commentError" class="modal-error">Заполните хотя бы один комментарий</div>

      <div class="modal-actions">
        <button class="operation-btn operation-secondary modal-submit" :disabled="loading" @click="apply">Отправить на согласование</button>
        <button class="operation-btn modal-cancel" :disabled="loading" @click="$emit('update:show', false)">Отмена</button>
      </div>
    </div>
  </div>
</template>

<script>
import { prettyPaymentTerm } from '../helpers';

export default {
  name: 'ApproveCreateModal',
  props: {
    show: { type: Boolean, default: false },
    order: { type: Object, required: true },
    request: { type: Object, default: null },
    loading: { type: Boolean, default: false },
  },
  emits: ['update:show', 'apply'],
  data() {
    return {
      whoCarrier: '',
      whyTariff: '',
      prevTerms: '',
      commentError: false,
    };
  },
  computed: {
    approved() {
      return this.order.approved_result || {};
    },
    summaryLines() {
      const fields = (this.request && this.request.fields) || {};
      const withNds = Boolean(this.request && this.request.withNds);
      const price = fields.new_cost_with_nds ?? fields.new_cost_without_nds ?? null;
      const lines = [
        {
          label: 'Цена',
          value: price != null
            ? `${Number(price).toLocaleString('ru-RU')} ${withNds ? 'с НДС' : 'без НДС'}`
            : 'без изменений',
          muted: price == null,
        },
        {
          label: 'Срок оплаты',
          value: fields.new_pay ? prettyPaymentTerm(fields.new_pay) : 'без изменений',
          muted: !fields.new_pay,
        },
        {
          label: 'Дата погрузки',
          value: fields.new_date ? this.formatDateTime(fields.new_date) : 'без изменений',
          muted: !fields.new_date,
        },
      ];
      return lines;
    },
  },
  watch: {
    show(value) {
      if (value) this.prefill();
    },
  },
  methods: {
    prefill() {
      this.whoCarrier = this.approved.who_carrier || '';
      this.whyTariff = this.approved.why_tariff || '';
      this.prevTerms = this.approved.prev_terms || '';
      this.commentError = false;
    },
    formatDateTime(value) {
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return '—';
      const pad = (n) => String(n).padStart(2, '0');
      return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
    },
    apply() {
      const comments = [this.whoCarrier, this.whyTariff, this.prevTerms]
        .map((value) => (value || '').trim())
        .filter(Boolean);
      if (!comments.length) {
        this.commentError = true;
        return;
      }
      this.commentError = false;

      const payload = { ...((this.request && this.request.fields) || {}) };
      if (this.whoCarrier.trim()) payload.who_carrier = this.whoCarrier.trim();
      if (this.whyTariff.trim()) payload.why_tariff = this.whyTariff.trim();
      if (this.prevTerms.trim()) payload.prev_terms = this.prevTerms.trim();

      this.$emit('apply', payload);
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.45);
}

.approve-modal {
  width: 460px;
  max-width: 92vw;
  max-height: 90vh;
  overflow: auto;
  padding: 16px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2);
}

.modal-title {
  margin: 0 0 6px;
  font-size: 16px;
  font-weight: 700;
  color: #333;
}

.modal-tip {
  margin: 0 0 12px;
  font-size: 13px;
  color: #666;
}

.summary {
  border: 1px solid #e3e7ec;
  border-radius: 8px;
  background: #f8fafd;
  padding: 8px 10px;
  margin-bottom: 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.summary-row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  font-size: 13px;
}

.summary-label {
  color: #7b8087;
  font-weight: 600;
}

.summary-value {
  color: #222;
  font-weight: 700;
  text-align: right;
}

.summary-value.muted {
  color: #9aa0a6;
  font-weight: 500;
}

.modal-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 10px;
}

.modal-label {
  font-size: 13px;
  color: #555;
  font-weight: 600;
}

.modal-field input {
  padding: 6px 8px;
  border: 1px solid #d7dce2;
  border-radius: 6px;
  font-size: 14px;
  font-family: inherit;
  width: 100%;
  box-sizing: border-box;
}

.modal-error {
  color: #b83235;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 8px;
}

.modal-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.modal-submit {
  flex: 1 1 auto;
  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.modal-submit:hover:not(:disabled) {
  background: #ffe9c9;
  border-color: #f0b26a;
}

.modal-cancel {
  flex: 0 1 auto;
  background: #fdecec;
  border-color: #e3a8a8;
  color: #b83235;
  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.modal-cancel:hover:not(:disabled) {
  background: #f9dcdc;
  border-color: #d98a8a;
  color: #8f1f22;
}

.operation-btn {
  padding: 6px 10px;
  border: 1px solid #d7dce2;
  border-radius: 6px;
  background: #fff;
  color: #333;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.operation-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.operation-secondary {
  background: #fff3e0;
  border-color: #f0b26a;
  color: #8a5300;
}
</style>
